// extracted by mini-css-extract-plugin
export default {"container":"WendingPath_container__3QxvA","navigation":"WendingPath_navigation__pgiIp","navigationItem":"WendingPath_navigationItem__Br1+1"};